import {
  Box,
  Button,
  Flex,
  Heading,
  HStack,
  Image,
  Text,
  VStack,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Divider,
  Tooltip,
  Stack,
  Skeleton,
  useToast,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  useDisclosure,
  Tbody,
  Thead,
  Table,
  TableContainer,
  Tr,
  Th,
  Td,
  Badge,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  ModalCloseButton,
  ModalHeader,
  ModalFooter,
  FormControl,
  FormLabel,
  Select,
  Input,
} from "@chakra-ui/react";
import { AiOutlineConsoleSql, AiOutlineDown } from "react-icons/ai";
import { MdDelete } from "react-icons/md";
import { Link } from "react-router-dom";
import axios from "axios";
import Tags from "./Tags";
import { Auth } from "./Auth";
import { useState, useContext, useEffect } from "react";
import DatePicker from "react-multi-date-picker";
import "../../src/style/datePicker.css";
import { Context } from "./store";
import moment from "moment";
const Details = ({
  title,
  order,
  orderDate,
  orderData,
  rent,
  btnColorScheme,
  btnText,
  productName,
  productBtnText,
  productBtnItems,
  row1,
  row2,
  status,
  title2,
  tenureTypeTotal,
  tenureType,
  orderDetails,
  deleteItemHandler,
  tenureLength,
  tenureId,
  orderId,
  deleteRenderMe,
  tenureData,
  partyId,
  orderTenure,
  returnData,
  renderOnReturnChange,
  returnDetails,
  handleChildStateChange,
  tenureTableId,
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  
  const [isOpen1, setIsOpen1] = useState(false);
  const onClose1 = () => setIsOpen1(false);
  const onOpen1 = () => setIsOpen1(true);

  const [isOpen2, setIsOpen2] = useState(false);
  const onClose2 = () => setIsOpen2(false);
  const onOpen2 = () => setIsOpen2(true);

  const [isOpen4, setIsOpen4] = useState(false);
  const onOpen4 = () => setIsOpen4(true);
  const onClose4 = () => setIsOpen4(false);

  const [isOpen3, setIsOpen3] = useState(false);
  const onClose3 = () => setIsOpen3(false);
  const onOpen3 = () => setIsOpen3(true);
  const [pickupDate, setPickupDate] = useState("");

  const [spinner, setSpinner] = useState(false);
  const [invoiceGenerated, setInvoiceGenerated] = useState(false);
  const [hourTwoFourRestriction, setHourTwoFourRestriction] = useState(false);
  const [tenureInvoiceData, setTenureInvoiceData] = useState([]);
  const [allTenureInvoice, setAllTenureInvoice] = useState([]);
  const toast = useToast();
  const returnColorScheme = returnData
    ? returnData?.ReturnItem[0]?.statusId === "ORDER_PICKED"
      ? "orange"
      : returnData?.ReturnItem[0]?.statusId === "RETURN_APPROVED"
      ? "green"
      : returnData?.ReturnItem[0]?.statusId === "ORDER_RETURNED"
      ? "yellow"
      : returnData?.ReturnItem[0]?.statusId === "ORDER_RESTOCKED"
      ? "purple"
      : returnData?.ReturnItem[0]?.statusId === "RETURN_CREATED"
      ? "pink"
      : returnData?.ReturnItem[0]?.statusId === "RETURN_CLOSED"
      ? "red"
      : returnData?.ReturnItem[0]?.statusId === "SETTLEMENT_CALCULATED"
      ? "facebook"
      : returnData?.ReturnItem[0]?.statusId === "RETURN_CLOSED"
      ? "red"
      : returnData?.ReturnItem[0]?.statusId === "QC_COMPLETED"
      ? "cyan"
      : returnData?.ReturnItem[0]?.statusId === "SETTLEMENT_CALCULATED"
      ? "facebook"
      : "blue"
    : null;

  const { userData } = useContext(Context);
  const user = userData;
  const userPermission = user.UserGroupPermission;

  const menuStyle = {
    fontSize: "12",
    fontWeight: "400",
    letterSpacing: "0.1",
    _first: {
      bgColor: "transparent",
    },
    _hover: {
      bgColor: "rgba(67, 138, 254, 0.1)",
    },
  };
  const menuButton = {
    px: "16px",
    py: "0",
    h: "36px",
    w: "203px",
    bgColor: "#FFFFFF",
    _hover: { bgColor: "rgba(67, 138, 254, 0.1)" },
    color: "#438AFE",
    border: "1px solid #438AFE",
  };

  const tableBorder = {
    borderCollapse: "separat",
    borderSpacing: "0px",
    borderRadius: "3px",
    boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.25)",
  };

  const tableRowBorder = {
    border: "1px solid rgba(0, 0, 0, 0.17)",
    bgColor: "white",
    _last: {
      borderRight: "unset",
    },
    _first: {
      borderLeft: "unset",
    },
  };

  console.log(returnData, "135648583654455");

  // status str format
  const convertStatus = (str) => {
    if (str) {
      // Split the string by underscores
      var words = str.split("_");

      // Capitalize the first letter of each word
      for (var i = 0; i < words.length; i++) {
        words[i] =
          words[i].charAt(0).toUpperCase() + words[i].slice(1).toLowerCase();
      }

      // Join the words with a space
      var result = words.join(" ");

      return result;
    }
  };

  // Generate next invoice automatic
  // const generateInvoiceHandler = () => {

  //     let data = JSON.stringify({
  //         "orderId": `${orderData.id}`,
  //         "orderItemSeqId": `${orderDetails.orderItemSeqId}`
  //       });

  //       let config = {
  //         method: 'post',
  //         maxBodyLength: Infinity,
  //         url: `${process.env.REACT_APP_RALCO_API_URL}/api/invoice/manual`,
  //         headers: {
  //           'Content-Type': 'application/json',
  //           'Authorization': Auth()
  //         },
  //         data : data
  //       };

  //       axios.request(config)
  //       .then((response) => {
  //         console.log(JSON.stringify(response.data));
  //         toast({
  //             title: 'Tenure invoice generated manually',
  //             description: `Invoice Date : ${new Date(response.data.invoiceDate).toLocaleDateString('en-IN')}`,

  //             status: 'success',
  //             position: 'top',
  //             duration: 5000,
  //             isClosable: true,
  //           })
  //           onClose()
  //       })
  //       .catch((error) => {
  //         console.log(error);
  //         toast({
  //             title: 'Oops we are facing some temporary issue with your request',
  //             status: 'error',
  //             position: 'top',
  //             duration: 3000,
  //             isClosable: true,
  //           })
  //       });

  // }

  // Cancel tenure handler
  const cancelTenureHandler = () => {
    let data = JSON.stringify({
      tenureDetail: {
        statusId: "CANCELED",
      },
    });

    let config = {
      method: "patch",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_RALCO_API_URL}/api/tenure/${tenureId}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: Auth(),
      },
      data: data,
    };

    axios
      .request(config)
      .then((response) => {
        toast({
          title: "TENURE CANCELED",
          status: "success",
          position: "top",
          duration: 4000,
          isClosable: true,
        });
        deleteRenderMe();
        onClose();
      })
      .catch((error) => {
        toast({
          title: "Oops we are facing some temporary issue with your request",
          status: "error",
          position: "top",
          duration: 3000,
          isClosable: true,
        });
        onClose();
      });
  };

  // Extend Tenure Handler
  const extendTenureHandler = () => {
    let e = JSON.parse(window.sessionStorage.getItem("extend-tenure"));
    let monthly = e.split(" ")[1].includes("Month");
    let weekly = e.split(" ")[1].includes("Week");
    let weeks = e.split(" ")[0];
    let months = e.split(" ")[0];
    // Get the time in IST
    const options = {
      timeZone: "Asia/Kolkata",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    };
    // Create a copy of the current date
    let nextDate = new Date(tenureData?.endDate);
    // Increment the date by 1 day to get the next date
    nextDate = new Intl.DateTimeFormat("en-GB", options).format(nextDate);
    nextDate = nextDate.split("/").reverse().join("-");
    const endDateCalculation = (dateParam) => {
      // Define the start date and duration
      dateParam = new Date(dateParam);
      //   let endDate = new Date(startDate.getTime() + ((Number(e.split(" ")[0]) * 30) + 7 ) * 24 * 60 * 60 * 1000);
      //   // Set the end date to the last day of the month
      //   endDate.setMonth(endDate.getMonth());
      //   endDate.setDate(0);
      // Format the end date
      if (monthly) {
        let endDate = moment(dateParam)
          .add(months, "months")
          .format("YYYY-MM-DD");
        return new Date(endDate).toISOString().slice(0, 10);
      } else if (weekly) {
        const oldWeeks = tenureData.TenureItem[0].weeks * 1;
        const newWeeks = weeks * 1 + oldWeeks;
        let endDate = moment(tenureData.startDate)
          .add(newWeeks, "weeks")
          .format("YYYY-MM-DD");
        return new Date(endDate).toISOString().slice(0, 10);
      }
    };

    let data = JSON.stringify({
      tenurePeriodType: monthly ? `MONTHLY` : `WEEKLY`,
      tenureId: `${tenureData.id}`,
      partyId: `${partyId}`,
      extendedStartDate: nextDate,
      extendedEndDate: endDateCalculation(nextDate),
      numberOfWeeks: weekly ? e.split(" ")[0] : null,
      netPayable: monthly
        ? Number(tenureData?.TenureItem[0]?.pricePerMonth) * e.split(" ")[0]
        : Number(tenureData?.TenureItem[0]?.pricePerWeek) * e.split(" ")[0],
    });
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_RALCO_API_URL}/api/tenure/extend/active-tenure`,
      headers: {
        "Content-Type": "application/json",
        Authorization: Auth(),
      },
      data: data,
    };

    axios
      .request(config)
      .then((response) => {
        if (response?.data?.message) {
          toast({
            title: `${response?.data?.message.split(",")[0]}`,
            status: "warning",
            position: "top",
            duration: 4000,
            isClosable: true,
          });
        } else {
          toast({
            title: `Tenure Extended for ${e}`,
            status: "success",
            position: "top",
            duration: 4000,
            isClosable: true,
          });
        }
        deleteRenderMe();
        window.sessionStorage.removeItem("extend-tenure");
        onClose1();
      })
      .catch((error) => {
        console.log(error);
        toast({
          title: "Oops we are facing some temporary issue with your request",
          status: "error",
          position: "top",
          duration: 3000,
          isClosable: true,
        });
        window.sessionStorage.removeItem("extend-tenure");
        onClose1();
      });
  };

  // ### CREATE RETURN HANDLER ###
  const createReturnHandler = () => {
    let data = JSON.stringify({
      orderId: `${orderId}`,
      orderItemSeqId: Number(orderDetails.orderItemSeqId),
    });

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_RALCO_API_URL}/api/return-order`,
      headers: {
        "Content-Type": "application/json",
        Authorization: Auth(),
      },
      data: data,
    };

    axios
      .request(config)
      .then((response) => {
        toast({
          title: `Return Created for -- ${orderDetails.title}`,
          status: "success",
          position: "top",
          duration: 4000,
          isClosable: true,
        });
        onClose2();
        renderOnReturnChange(response.data.createdAt); // to render order details page
      })
      .catch((error) => {
        console.log(error);
        onClose2();
        toast({
          title: "Oops we are facing some temporary issue with your request",
          status: "error",
          position: "top",
          duration: 3000,
          isClosable: true,
        });
      });
  };

  // Reshcedule Pickup

  const reschedulePickupHandler = () => {
    let data = JSON.stringify({
      orderId: `${returnDetails?.ReturnItem[0]?.orderId}`,
      orderItemSeqId: Number(returnDetails?.ReturnItem[0]?.orderItemSeqId),
      returnId: `${returnDetails?.id}`,
      returnOrderStatusId: `${returnDetails?.statusId}`,
      returnOrderItemStatusId: `${returnDetails?.ReturnItem[0]?.statusId}`,
      pickupDate: `${new Date(pickupDate).toISOString()}`,
      returnItemSeqId: Number(returnDetails?.ReturnItem[0]?.returnItemSeqId),
      dropLocation: "",
      warehouseAddress: "",
    });

    let config = {
      method: "patch",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_RALCO_API_URL}/api/return-order`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios
      .request(config)
      .then((response) => {
        console.log(JSON.stringify(response.data));

        toast({
          title: `Pickup Date Reschedule Successfully`,
          status: "success",
          position: "top",
          duration: 4000,
          isClosable: true,
        });
        onClose3();
        handleChildStateChange(Math.random() + 1);
        setHourTwoFourRestriction(false);
      })
      .catch((error) => {
        console.log(error);
        toast({
          title: `Oops we are facing some temporary issue with your request`,
          status: "error",
          duration: 3000,
          position: "top",
          isClosable: true,
        });
        onClose3();
        setHourTwoFourRestriction(false);
      });
  };
  // Hour restriction check
  const hourRestrictionCheck = () => {
    // Get the current date and time
    const currentDate = new Date();

    // Get the given date and time (replace with your specific date)
    const givenDate = new Date(returnDetails?.ReturnItem[0]?.pickupDate || ""); // Example date and time

    // Calculate the time difference in milliseconds
    const timeDifference = givenDate - currentDate;

    // Calculate the time difference in hours
    const hoursDifference = timeDifference / (1000 * 60 * 60);

    // Disable the div if the time difference is within 24 hours
    if (hoursDifference <= 24) {
      setHourTwoFourRestriction(true);
    } else {
      setHourTwoFourRestriction(false);
    }
  };

  useEffect(() => {
    hourRestrictionCheck();
  });

  // Tenure Data to generate tenure invoice
  useEffect(() => {
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_RALCO_API_URL}/api/tenure/get-tenure-list`,
      headers: {
        Authorization: Auth(),
      },
      data: { orderId: orderId },
    };
    if (title === "Order") {
      axios
        .request(config)
        .then((response) => {
          let temp = response.data.filter((x) => x.tenureId === tenureId);
          setTenureInvoiceData(temp);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, []);

  // Get all tenure invoice
  useEffect(() => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_RALCO_API_URL}/api/invoice?tenureId=${tenureId}`,
      headers: {
        Authorization: Auth(),
      },
    };
    if (title === "Order") {
      axios
        .request(config)
        .then((response) => {
          console.log(response.data, "running....");
          setAllTenureInvoice(response.data);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [invoiceGenerated, setInvoiceGenerated, toast, spinner]);

  // To create invoice/tenure ticket
  // const freshDeskTicket = async (id) => {
  //       let data = {ids: [id]}

  //       let config = {
  //         method: 'post',
  //         maxBodyLength: Infinity,
  //         url: `${process.env.REACT_APP_RALCO_API_URL}/api/freshdesk/tenure-invoice-ticket`,
  //         headers: {
  //           'Content-Type': 'application/json'
  //         },
  //         data : data
  //       };

  //       let response = await axios.request(config)

  //       return response.data
  // }

  const shopifyOrderPageUrl = (draft, id) => {
    if (draft) {
      return `${process.env.REACT_APP_SHOPIFY_ENDPOINT}/draft_orders/${id}`;
    } else {
      return `${process.env.REACT_APP_SHOPIFY_ENDPOINT}/orders/${id}`;
    }
  };

  // === Generate Invoice === 04-sep-2023
  const generateInvoice = (seqId) => {
    setSpinner(true);
    let data = JSON.stringify({
      tenureId: `${tenureId}`,
      tenureItemSeqId: Number(seqId),
    });

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_RALCO_API_URL}/api/invoice/create/tenure-item-invoice`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios
      .request(config)
      .then((response) => {
        setSpinner(false);
        // Calling function to create tenure ticket
        //  freshDeskTicket(response.data.id).then((resp)=>{
        //     if(resp && resp.error === false && !(resp.data === null)){
        //         toast({
        //             title: "Tenure invoice generated manually",
        //             status: "success",
        //             position: "top",
        //             duration: 4000,
        //             isClosable: true,
        //           });
        //           setInvoiceGenerated(true)
        //           handleChildStateChange(Math.random() + 1)
        //     }else{
        //         toast({
        //             title: "Tenure invoice ticket generation failed",
        //             status: "error",
        //             position: "top",
        //             duration: 4000,
        //             isClosable: true,
        //           });
        //     }
        //   })
      })
      .catch((err) => {
        console.log(err);
        setSpinner(false);
        setInvoiceGenerated(false);
      })
      .catch((error) => {
        setSpinner(false);
        setInvoiceGenerated(false);
        console.log(error);
      });
  };

  const [isOpen5, setIsOpen5] = useState(false);
  const onClose5 = () => setIsOpen5(false);
  const onOpen5 = () => setIsOpen5(true);
  const [selectedBillingDay, setSelectedBillingDay] = useState("");

  // Update billing day handler
  const updateBillingDay = () => {
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_RALCO_API_URL}/api/tenure/${tenureId}/billing-day`,
      headers: {
        "Content-Type": "application/json",
        Authorization: Auth(),
      },
      data: { billingDay: selectedBillingDay },
    };

    axios
      .request(config)
      .then((response) => {
        toast({
          title: "Billing day updated successfully",
          status: "success",
          position: "top",
          duration: 4000,
          isClosable: true,
        });
        onClose5();
        deleteRenderMe();
      })
      .catch((error) => {
        toast({
          title: "Failed to update billing day",
          status: "error",
          position: "top",
          duration: 3000,
          isClosable: true,
        });
      });
  };

  const [isEditingRlNumber, setIsEditingRlNumber] = useState(false);
  const [rlNumber, setRlNumber] = useState(orderDetails?.rlNumber || "");
  const [isUpdatingRlNumber, setIsUpdatingRlNumber] = useState(false);

  const handleRlNumberUpdate = () => {
    setIsUpdatingRlNumber(true);

    let config = {
      method: "patch",
      url: `${process.env.REACT_APP_RALCO_API_URL}/api/order/${orderData.id}/update-order-item`,
      headers: {
        "Content-Type": "application/json",
        Authorization: Auth(),
      },
      data: {
        rlNumber: rlNumber,
        orderItemSeqId: orderDetails.orderItemSeqId,
        orderId: orderData.id,
      },
    };

    axios
      .request(config)
      .then((response) => {
        toast({
          title: "RL Number updated successfully",
          status: "success",
          position: "top",
          duration: 3000,
          isClosable: true,
        });
        setIsEditingRlNumber(false);
        window.location.reload();
      })
      .catch((error) => {
        toast({
          title: "Failed to update RL Number",
          description:
            error.response?.data?.message || "Please try again later",
          status: "error",
          position: "top",
          duration: 3000,
          isClosable: true,
        });
      })
      .finally(() => {
        setIsUpdatingRlNumber(false);
      });
  };
  console.log(orderDetails, "orderDetails")
  

  return (
    <Box
      my={5}
      mt={{ base: 3, md: 5, lg: 5, xl: 5, "2xl": 5 }}
      bgColor={"#FFFFFF"}
    >
      {/* ### HEAD PART ### */}
      {title !== "Order Summary" && title !== "Order" && (
        <Heading
          fontSize={{
            base: "15px",
            md: "20px",
            lg: "20px",
            xl: "20px",
            "2xl": "20px",
          }}
          pb={2}
          bgColor={"#F5F5F5"}
        >
          {title} Details
        </Heading>
      )}
      <Box shadow={"md"} rounded={"md"} border={"1px"} borderColor={"gray.200"}>
        <Box bgColor={"rgba(217, 217, 217, 0.55)"} p={3}>
          <HStack spacing={12} justifyContent={"space-between"}>
            <Flex
              flexDirection={"row"}
              flexBasis={{
                base: "100%",
                md: "90%",
                lg: "90%",
                xl: "90%",
                "2xl": "90%",
              }}
            >
              <Box mr={6}>
                <Text
                  fontSize={{
                    base: "xs",
                    md: "sm",
                    lg: "sm",
                    xl: "sm",
                    "2xl": "sm",
                  }}
                  fontWeight={"medium"}
                >
                  {order}
                </Text>
                <Text
                  fontSize={{
                    base: "11px",
                    md: "sm",
                    lg: "sm",
                    xl: "sm",
                    "2xl": "sm",
                  }}
                  fontWeight={"bold"}
                >
                  {orderDate}
                </Text>
              </Box>

              {title === "Tenure" && (
                <>
                  {tenureType !== undefined &&
                    !tenureTypeTotal?.includes(NaN) && (
                      <Box mr={6}>
                        <Text fontSize={"sm"} fontWeight={"medium"}>
                          {tenureType}
                        </Text>
                        <Text fontSize={"sm"} fontWeight={"bold"}>
                          {tenureTypeTotal}
                        </Text>
                      </Box>
                    )}
                </>
              )}

              <Box mt={"6px"}>
                {btnText === undefined ? (
                  <Stack w={20}>
                    <Skeleton height="5px" />
                    <Skeleton height="5px" />
                  </Stack>
                ) : (
                  <Button
                    colorScheme={btnColorScheme}
                    size={{
                      base: "xs",
                      md: "sm",
                      lg: "sm",
                      xl: "sm",
                      "2xl": "sm",
                    }}
                    rounded={"full"}
                    cursor={"default"}
                  >
                    {convertStatus(btnText)}
                  </Button>
                )}
              </Box>

              <Box mt={"6px"} ml={3}>
                {title === "Order" &&
                  title2 !== "Order Delivery" &&
                  orderData?.orderStatusId !== "ORDER_DRAFT" &&
                  orderData?.orderStatusId !== "ORDER_PUBLISHED" &&
                  orderData?.orderStatusId !== "ORDER_CANCELED" &&
                  tenureType &&
                  tenureType === "Monthly Tenure" &&
                  orderData?.orderStatusId === "ORDER_DELIVERED" && (
                    <Button
                      colorScheme={"teal"}
                      size={{
                        base: "xs",
                        md: "sm",
                        lg: "sm",
                        xl: "sm",
                        "2xl": "sm",
                      }}
                      rounded={"full"}
                      cursor={"pointer"}
                      onClick={onOpen4}
                    >
                      {"Generate Tenure Invoice"}
                    </Button>
                  )}
              </Box>

              {tenureLength === 0 && (
                <Box mt={"6px"} ml={3}>
                  <Button colorScheme={"red"} size={"sm"} rounded={"full"}>
                    {"Generate Tenure"}
                  </Button>
                </Box>
              )}
            </Flex>
            {/* Delete Button Order Summary */}
            {title === "Order Summary" && (
              <Tooltip label="Delete Order Item">
                <Flex
                  flexBasis={"10%"}
                  alignItems={"center"}
                  justifyContent={"end"}
                >
                  <MdDelete
                    color={"#ED2B2A"}
                    fontSize={"28px"}
                    style={{ cursor: "pointer" }}
                    onClick={() => deleteItemHandler(orderDetails.id)}
                  />
                </Flex>
              </Tooltip>
            )}
          </HStack>
        </Box>
        {/* ### MAIN BODY PART ### */}
        <Box m={5} bgColor={"#FFFFF"}>
          <Flex
            justifyContent={"space-between"}
            flexDirection={{
              base: "column",
              md: "row",
              lg: "row",
              xl: "row",
              "2xl": "row",
            }}
          >
            <Flex
              flexBasis={title !== "Order" ? "60%" : "100%"}
              mb={{
                base: "15px",
                md: "0px",
                lg: "0px",
                xl: "0px",
                "2xl": "0px",
              }}
            >
              <HStack spacing={5}>
                <Image
                  src={
                    orderDetails?.img ||
                    "https://cdn.shopify.com/s/files/1/0697/5451/9829/products/90e92ddb34394a5f0905c9276f3bb149.png?v=1678428883"
                  }
                  height={{
                    base: "75px",
                    md: "100px",
                    lg: "100px",
                    xl: "100px",
                    "2xl": "100px",
                  }}
                  width={{
                    base: "120px",
                    md: "150px",
                    lg: "150px",
                    xl: "150px",
                    "2xl": "150px",
                  }}
                  alt="item-img"
                />
                <Flex flexDirection={"column"}>
                  <Text
                    fontSize={{
                      base: "sm",
                      md: "lg",
                      lg: "lg",
                      xl: "lg",
                      "2xl": "lg",
                    }}
                    fontWeight={"semibold"}
                  >
                    {orderDetails?.title || "Product Title"}
                  </Text>
                  {orderDetails.variant !== "n/a" && (
                    <Text
                      fontSize={{
                        base: "xs",
                        md: "sm",
                        lg: "sm",
                        xl: "sm",
                        "2xl": "sm",
                      }}
                    >
                      <Text as="span" fontWeight={"semibold"}>
                        Variant :{" "}
                      </Text>
                      {orderDetails?.variant === "n/a"
                        ? ""
                        : orderDetails?.variant || "Variant title"}
                    </Text>
                  )}
                  {title === "Order" && (
                    <>
                      {orderDetails.productGeneration !== "n/a" && (
                        <Text
                          fontSize={{
                            base: "xs",
                            md: "sm",
                            lg: "sm",
                            xl: "sm",
                            "2xl": "sm",
                          }}
                        >
                          <Text as="span" fontWeight={"semibold"}>
                            Generation :{" "}
                          </Text>
                          {orderDetails.productGeneration}
                        </Text>
                      )}
                      {orderDetails.productOperatingSystem !== "n/a" && (
                        <Text
                          fontSize={{
                            base: "xs",
                            md: "sm",
                            lg: "sm",
                            xl: "sm",
                            "2xl": "sm",
                          }}
                        >
                          <Text as="span" fontWeight={"semibold"}>
                            Operating System :{" "}
                          </Text>
                          {orderDetails.productOperatingSystem}
                        </Text>
                      )}
                      {orderDetails.productProcessor !== "n/a" && (
                        <Text
                          fontSize={{
                            base: "xs",
                            md: "sm",
                            lg: "sm",
                            xl: "sm",
                            "2xl": "sm",
                          }}
                        >
                          <Text as="span" fontWeight={"semibold"}>
                            Processor :{" "}
                          </Text>
                          {orderDetails.productProcessor}
                        </Text>
                      )}
                      {orderDetails.selectedGamesType !== "n/a" && (
                        <Text
                          fontSize={{
                            base: "xs",
                            md: "sm",
                            lg: "sm",
                            xl: "sm",
                            "2xl": "sm",
                          }}
                        >
                          <Text as="span" fontWeight={"semibold"}>
                            Game :{" "}
                          </Text>
                          {orderDetails.selectedGamesType
                            .split(",")
                            .join(" | ")}
                        </Text>
                      )}
                    </>
                  )}
                </Flex>
              </HStack>
            </Flex>

            <Flex flexBasis={"40%"} justifyContent={"end"}>
              {title !== "Order Summary" && (
                <VStack
                  flexDirection={{
                    base: "row",
                    md: "column",
                    lg: "column",
                    xl: "column",
                    "2xl": "column",
                  }}
                  justifyContent={{
                    base: "space-between",
                    md: "center",
                    lg: "center",
                    xl: "center",
                    "2xl": "center",
                  }}
                  width={{
                    base: "100%",
                    md: "auto",
                    lg: "auto",
                    xl: "auto",
                    "2xl": "auto",
                  }}
                >
                  {title === "Tenure" &&
                    status !== "CANCELED" &&
                    status !== "ENDED" && (
                      <Button
                        variant={"outline"}
                        colorScheme={"blue"}
                        fontSize={{
                          base: "14px",
                          md: "16px",
                          lg: "16px",
                          xl: "16px",
                          "2xl": "16px",
                        }}
                        width={{
                          base: "120px",
                          md: "200px",
                          lg: "200px",
                          xl: "200px",
                          "2xl": "200px",
                        }}
                        onClick={onOpen}
                      >
                        Cancel {title}
                      </Button>
                    )}
                  {/* {title2 === "Order Delivery" && <Button variant={'outline'} colorScheme={'blue'} fontSize={{ base: '14px', md: '16px', lg: '16px', xl: '16px', '2xl': '16px' }} width={{ base: '120px', md: '200px', lg: '200px', xl: '200px', '2xl': '200px' }} >Cancel Delivery</Button>} */}

                  {/* {(title2 === "Order Delivery") && <Button variant={'outline'} colorScheme={'blue'} fontSize={{ base: '14px', md: '16px', lg: '16px', xl: '16px', '2xl': '16px' }} width={{ base: '100%', md: '200px', lg: '200px', xl: '200px', '2xl': '200px' }} marginTop={{ base: '0px !important', md: '8px !important', lg: '8px !important', xl: '8px !important', '2xl': '8px !important' }} >Reschedule {title}</Button>} */}

                  {title === "Order" &&
                    (orderData?.orderStatusId === "ORDER_DELIVERED" ||
                      orderData?.orderStatusId === "ORDER_RETURNED" ||
                      orderData?.orderStatusId === "TERMINATED") && (
                      <>
                        {(returnData &&
                          returnData?.ReturnItem[0]?.statusId ===
                            "RETURN_CLOSED") ||
                        !(returnData && returnData?.ReturnItem[0]?.statusId) ? (
                          <>
                            <Tooltip label="Create return for this item">
                              <Button
                                colorScheme={"teal"}
                                variant={"outline"}
                                onClick={onOpen2}
                              >
                                Create Return
                              </Button>
                            </Tooltip>
                          </>
                        ) : (
                          <>
                            <Text
                              fontWeight={"bold"}
                              fontSize={{
                                base: "11.5px",
                                md: "sm",
                                lg: "md",
                                xl: "md",
                                "2xl": "md",
                              }}
                              color={"blackAlpha.500"}
                            >
                              Return Status
                            </Text>
                            <Tooltip label="Go to return order item details page">
                              <Link
                                to={`/returns/return/${
                                  returnData &&
                                  returnData.ReturnItem &&
                                  returnData.ReturnItem.length > 0 &&
                                  returnData?.ReturnItem[0]?.returnId
                                }/order/${orderId}`}
                                style={{ marginTop: "0px" }}
                              >
                                <Button
                                  colorScheme={returnColorScheme}
                                  size={{
                                    base: "xs",
                                    md: "sm",
                                    lg: "sm",
                                    xl: "sm",
                                    "2xl": "sm",
                                  }}
                                  rounded={"full"}
                                  cursor={"pointer"}
                                >
                                  {convertStatus(
                                    returnData &&
                                      returnData.ReturnItem &&
                                      returnData.ReturnItem.length > 0 &&
                                      returnData?.ReturnItem[0]?.statusId
                                  )}
                                </Button>
                              </Link>
                            </Tooltip>
                          </>
                        )}
                      </>
                    )}

                  {/* {(title === "Return") && <Button colorScheme={'twitter'} variant={'outline'} px={6}>Cancel Pickup</Button>} */}

                  {title === "Return" &&
                    (returnDetails?.ReturnItem[0]?.pickupDate?.length > 0 ||
                      returnDetails?.ReturnItem[0]?.pickupDate !== null) &&
                    (user.userGroupMember.includes("ADMIN") ||
                      (user.userGroupMember.includes("MEMBER") &&
                        userPermission.includes("ORDER_MANAGEMENT"))) && (
                      <Button
                        isDisabled={
                          hourTwoFourRestriction ||
                          returnDetails.statusId !== "RETURN_APPROVED"
                        }
                        colorScheme={"twitter"}
                        variant={"outline"}
                        fontSize={{
                          base: "14px",
                          md: "16px",
                          lg: "16px",
                          xl: "16px",
                          "2xl": "16px",
                        }}
                        width={{
                          base: "100%",
                          md: "200px",
                          lg: "200px",
                          xl: "200px",
                          "2xl": "200px",
                        }}
                        marginTop={{
                          base: "0px !important",
                          md: "8px !important",
                          lg: "8px !important",
                          xl: "8px !important",
                          "2xl": "8px !important",
                        }}
                        onClick={onOpen3}
                      >
                        Reschedule Pickup
                      </Button>
                    )}

                  {/* <Button rightIcon={<AiOutlineDown />} bgColor={'gray.300'} width={200} >{productBtnText}</Button> */}

                  {/* {status} {title} {productBtnItems} */}
                  {/* Extend Tenure Functionality */}
                  {(productBtnItems !== undefined || title !== "Order") &&
                    status !== "CANCELED" &&
                    status !== "CREATED" &&
                    status !== "ENDED" && (
                      <Menu width={200}>
                        <MenuButton
                          rightIcon={<AiOutlineDown />}
                          as={Button}
                          sx={menuButton}
                        >
                          {productBtnText}
                        </MenuButton>
                        <MenuList
                          h={{
                            base: `${window.innerHeight - 390}px`,
                            md: `${window.innerHeight - 390}px`,
                            lg: `${window.innerHeight - 390}px`,
                            xl: `${window.innerHeight - 390}px`,
                            "2xl": "auto",
                          }}
                          overflowY={"scroll"}
                        >
                          {productBtnItems?.map((e, i) => {
                            return (
                              <MenuItem
                                key={i}
                                sx={menuStyle}
                                onClick={() => {
                                  onOpen1();
                                  window.sessionStorage.setItem(
                                    "extend-tenure",
                                    JSON.stringify(e)
                                  );
                                }}
                              >
                                {e}
                              </MenuItem>
                            );
                          })}
                        </MenuList>
                      </Menu>
                    )}
                </VStack>
              )}

              {/* Order Item Amount -- order summay (while creation) */}
              {title === "Order Summary" && (
                <VStack width={"100%"}>
                  <Box mt={0} width={"100%"}>
                    {/* <Flex justifyContent={"space-between"}>
                                    <Text
                                    fontSize={"12px"}
                                    letterSpacing={"wide"}
                                    flexBasis={"51%"}
                                    fontWeight={"semibold"}
                                    >
                                    Quantity
                                    </Text>
                                    <Text flexBasis={"2%"} textAlign={"right"} fontSize={"12px"} fontWeight={"semibold"}>
                                    :
                                    </Text>
                                    <Text flexBasis={"47%"} textAlign={"right"} fontSize={"12px"} fontWeight={"semibold"}>
                                    {Number(orderDetails?.quantity)}
                                    </Text>
                                </Flex> */}
                    <Flex justifyContent={"space-between"}>
                      <Text
                        fontSize={"12px"}
                        letterSpacing={"wide"}
                        flexBasis={"51%"}
                        fontWeight={"semibold"}
                      >
                        Base Price
                      </Text>
                      <Text
                        flexBasis={"2%"}
                        textAlign={"right"}
                        fontSize={"12px"}
                        fontWeight={"semibold"}
                      >
                        :
                      </Text>
                      <Text
                        flexBasis={"47%"}
                        textAlign={"right"}
                        fontSize={"12px"}
                        fontWeight={"semibold"}
                      >
                        ₹
                        {Number(orderDetails?.itemPrice).toLocaleString(
                          "en-IN",
                          { minimumFractionDigits: 2, maximumFractionDigits: 2 }
                        )}
                      </Text>
                    </Flex>
                    <Flex justifyContent={"space-between"}>
                      <Text
                        fontSize={"12px"}
                        letterSpacing={"wide"}
                        flexBasis={"51%"}
                        fontWeight={"semibold"}
                      >
                        Tenure Discount
                      </Text>
                      <Text
                        flexBasis={"2%"}
                        textAlign={"right"}
                        fontSize={"12px"}
                        fontWeight={"semibold"}
                      >
                        :
                      </Text>
                      <Text
                        flexBasis={"47%"}
                        textAlign={"right"}
                        fontSize={"12px"}
                        fontWeight={"semibold"}
                      >
                        ₹
                        {Number(orderDetails?.discount).toLocaleString(
                          "en-IN",
                          { minimumFractionDigits: 2, maximumFractionDigits: 2 }
                        )}
                      </Text>
                    </Flex>
                    <Flex justifyContent={"space-between"}>
                      <Text
                        fontSize={"12px"}
                        letterSpacing={"wide"}
                        flexBasis={"51%"}
                        fontWeight={"semibold"}
                      >
                        Subtotal
                      </Text>
                      <Text
                        flexBasis={"2%"}
                        textAlign={"right"}
                        fontSize={"12px"}
                        fontWeight={"semibold"}
                      >
                        :
                      </Text>
                      <Text
                        flexBasis={"47%"}
                        textAlign={"right"}
                        fontSize={"12px"}
                        fontWeight={"semibold"}
                      >
                        ₹
                        {Number(orderDetails?.subTotal).toLocaleString(
                          "en-IN",
                          { minimumFractionDigits: 2, maximumFractionDigits: 2 }
                        )}
                      </Text>
                    </Flex>
                    <Flex justifyContent={"space-between"}>
                      <Text
                        fontSize={"12px"}
                        letterSpacing={"wide"}
                        flexBasis={"51%"}
                        fontWeight={"semibold"}
                      >
                        Total Tax{" "}
                        <Text
                          as={"span"}
                          fontSize={"10px"}
                          fontWeight={"semibold"}
                        >{`(18% GST)`}</Text>
                      </Text>
                      <Text
                        flexBasis={"2%"}
                        textAlign={"right"}
                        fontSize={"12px"}
                        fontWeight={"semibold"}
                      >
                        :
                      </Text>
                      <Text
                        flexBasis={"47%"}
                        textAlign={"right"}
                        fontSize={"12px"}
                        fontWeight={"semibold"}
                      >
                        ₹
                        {Number(
                          Number(orderDetails?.subTotal) * 0.18
                        ).toLocaleString("en-IN", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </Text>
                    </Flex>
                    <Flex justifyContent={"space-between"}>
                      <Text
                        fontSize={"12px"}
                        letterSpacing={"wide"}
                        flexBasis={"51%"}
                        fontWeight={"semibold"}
                      >
                        Security Deposite
                      </Text>
                      <Text
                        flexBasis={"2%"}
                        textAlign={"right"}
                        fontSize={"12px"}
                        fontWeight={"semibold"}
                      >
                        :
                      </Text>
                      <Text
                        flexBasis={"47%"}
                        textAlign={"right"}
                        fontSize={"12px"}
                        fontWeight={"semibold"}
                      >
                        ₹
                        {Number(orderDetails?.securityDeposit).toLocaleString(
                          "en-IN",
                          { minimumFractionDigits: 2, maximumFractionDigits: 2 }
                        )}
                      </Text>
                    </Flex>

                    <Flex justifyContent={"space-between"} mt={1}>
                      <Text
                        fontSize={"12px"}
                        letterSpacing={"wide"}
                        flexBasis={"51%"}
                        fontWeight={"bold"}
                      >
                        Total
                      </Text>
                      <Text
                        flexBasis={"2%"}
                        textAlign={"right"}
                        fontSize={"12px"}
                        fontWeight={"bold"}
                      >
                        :
                      </Text>
                      <Text
                        flexBasis={"47%"}
                        textAlign={"right"}
                        fontWeight={"bold"}
                        fontSize={"12px"}
                      >
                        ₹
                        {Number(orderDetails?.totalPrice).toLocaleString(
                          "en-IN",
                          { minimumFractionDigits: 2, maximumFractionDigits: 2 }
                        )}
                      </Text>
                    </Flex>
                  </Box>
                </VStack>
              )}
            </Flex>
          </Flex>
        </Box>
        <hr />
        <Box p={3} px={{ base: 3, md: 6, lg: 6, xl: 6, "2xl": 6 }}>
          <Text
            fontWeight={"bold"}
            fontSize={{
              base: "11.5px",
              md: "sm",
              lg: "sm",
              xl: "sm",
              "2xl": "sm",
            }}
            color={"blackAlpha.500"}
          >
            RL Number
          </Text>
          <Flex alignItems="center">
            {isEditingRlNumber ? (
              <>
                <Input
                  size="sm"
                  value={rlNumber}
                  onChange={(e) => setRlNumber(e.target.value)}
                  width="150px"
                  mr={2}
                  placeholder="Enter RL Number"
                />
                <Button
                  size="sm"
                  colorScheme="green"
                  onClick={handleRlNumberUpdate}
                  isLoading={isUpdatingRlNumber}
                  mr={2}
                >
                  Save
                </Button>
                <Button
                  size="sm"
                  onClick={() => {
                    setIsEditingRlNumber(false);
                    setRlNumber(rlNumber || "");
                  }}
                >
                  Cancel
                </Button>
              </>
            ) : (
              <>
                <Text
                  fontSize={{
                    base: "15px",
                    md: "md",
                    lg: "md",
                    xl: "md",
                    "2xl": "md",
                  }}
                  fontWeight={"semibold"}
                  mr={2}
                >
                  {rlNumber || "n/a"}
                </Text>
                <Button
                  size="sm"
                  variant="ghost"
                  colorScheme="blue"
                  onClick={() => setIsEditingRlNumber(true)}
                >
                  Edit
                </Button>
              </>
            )}
          </Flex>
        </Box>

        {/* Additional Details for order management || also default to other module */}
        {(title === "Order Summary" ||
          title === "Order" ||
          title === "Delivery" ||
          title === "Return" ||
          title === "Delivery Return" ||
          title === "Tenure") && (
          <Box p={3} px={{ base: 3, md: 6, lg: 6, xl: 6, "2xl": 6 }} pt={0}>
            <Divider size={1} borderBottomColor={"black"} />
            <HStack spacing={10} py={2} my={2} justifyContent={"space-between"}>
              {row1?.map((r, i) => (
                <Box key={i}>
                  <Text
                    fontWeight={"bold"}
                    fontSize={{
                      base: "11.5px",
                      md: "sm",
                      lg: "sm",
                      xl: "sm",
                      "2xl": "sm",
                    }}
                    color={"blackAlpha.500"}
                  >
                    {Object.keys(r)[0]}
                  </Text>
                  {Object.keys(r)[0] === "Order ID" && title === "Tenure" ? (
                    <Tooltip label="Order Details">
                      <Link to={`/orders/order/${orderId}`}>
                        <Text
                          color={"blue.500"}
                          fontWeight={"semibold"}
                          fontSize={"sm"}
                        >
                          {Object.values(r)[0].includes("#")
                            ? Object.values(r)[0]
                            : "Draft"}
                        </Text>
                      </Link>
                    </Tooltip>
                  ) : (
                    <Text
                      fontWeight={"semibold"}
                      fontSize={{
                        base: "11px",
                        md: "sm",
                        lg: "sm",
                        xl: "sm",
                        "2xl": "sm",
                      }}
                    >
                      {r[Object.keys(r)[0]]}
                    </Text>
                  )}

                  {order.rlNumber}
                </Box>
              ))}
            </HStack>
            {(title !== "Order" || title !== "Tenure") && (
              <HStack
                spacing={10}
                py={2}
                my={2}
                justifyContent={"space-between"}
              >
                {row2?.map((r, i) => (
                  <Box key={i}>
                    <Text
                      fontWeight={"bold"}
                      fontSize={"md"}
                      color={"blackAlpha.500"}
                    >
                      {Object.keys(r)[0]}
                    </Text>
                    {/* ## TENURE LINK IN ORDER DETIALS PAGE */}
                    {Object.keys(r)[0] === "Tenure ID" ? (
                      <>
                        {r[Object.keys(r)[0]]?.includes("undefined") ? (
                          "----"
                        ) : (
                          <Tooltip label="Tenure Details">
                            <Link
                              to={`/tenures/order/${orderId}/tenure/${tenureId}`}
                            >
                              <Text
                                color={"blue.500"}
                                fontWeight={"semibold"}
                                fontSize={"sm"}
                              >
                                #{tenureId.split("-")[4] || "n/a"}
                              </Text>
                            </Link>
                          </Tooltip>
                        )}
                      </>
                    ) : (
                      <Text fontWeight={"semibold"} fontSize={"sm"}>
                        {r[Object.keys(r)[0]]?.includes("undefined") ||
                        r[Object.keys(r)[0]]?.includes("Invalid Date")
                          ? "----"
                          : r[Object.keys(r)[0]]}
                      </Text>
                    )}
                  </Box>
                ))}
              </HStack>
            )}

            {/* ### Order Details Table */}
            {(title === "Order" || title === "Return") && (
              <ShowTable
                id={tenureTableId}
                tableRowBorder={tableRowBorder}
                tableBorder={tableBorder}
                orderId={orderId}
              />
            )}

            {/* ### TENURE DETIALS TABLE */}
            {title === "Tenure" &&
              Object.keys(orderTenure).length > 0 &&
              orderTenure.active.length > 0 && (
                <HStack
                  spacing={10}
                  py={2}
                  my={2}
                  justifyContent={"space-between"}
                >
                  <TableContainer my={3} sx={tableBorder} width={"100%"}>
                    <Table variant={"simple"} size={"xs"}>
                      <Thead
                        borderRadius={"3px 3px 0px 0px"}
                        bgColor={"rgba(226, 223, 223, 1)"}
                      >
                        <Tr>
                          <Th
                            p={3}
                            borderRight={"1px solid rgba(0, 0, 0, 0.17)"}
                            fontSize={"9px"}
                          >
                            Tenure ID
                          </Th>
                          <Th
                            p={3}
                            borderRight={"1px solid rgba(0, 0, 0, 0.17)"}
                            fontSize={"9px"}
                          >
                            Tenure Type
                          </Th>
                          <Th
                            p={3}
                            borderRight={"1px solid rgba(0, 0, 0, 0.17)"}
                            fontSize={"9px"}
                          >
                            Tenure Start Date
                          </Th>
                          <Th
                            p={3}
                            borderRight={"1px solid rgba(0, 0, 0, 0.17)"}
                            fontSize={"9px"}
                          >
                            Tenure End Date
                          </Th>
                          <Th
                            p={3}
                            borderRight={"1px solid rgba(0, 0, 0, 0.17)"}
                            fontSize={"9px"}
                          >
                            Tenure Billing Day
                          </Th>
                          <Th
                            p={3}
                            borderRight={"1px solid rgba(0, 0, 0, 0.17)"}
                            fontSize={"9px"}
                          >
                            Duration
                          </Th>
                          <Th
                            p={3}
                            _last={{ borderRight: "unset" }}
                            borderRight={"1px solid rgba(0, 0, 0, 0.17)"}
                            fontSize={"9px"}
                          >
                            Status
                          </Th>
                        </Tr>
                      </Thead>
                      <Tbody>
                        <Tr>
                          <Td sx={tableRowBorder} fontSize={"xs"} p={3}>
                            #{orderTenure.active[0].tenureId}
                          </Td>
                          <Td sx={tableRowBorder} fontSize={"xs"} p={3}>
                            {orderTenure.active[0].tenure.tenurePeriodId}
                          </Td>
                          <Td sx={tableRowBorder} fontSize={"xs"} p={3}>
                            {new Date(
                              orderTenure.active[0].tenure.startDate
                            ).toLocaleDateString("en-IN")}
                          </Td>
                          <Td sx={tableRowBorder} fontSize={"xs"} p={3}>
                            {new Date(
                              orderTenure.active[0].tenure.endDate
                            ).toLocaleDateString("en-IN")}
                          </Td>
                          <Td sx={tableRowBorder} fontSize={"xs"} p={3}>
                            {orderTenure.active[0].tenure.billingDay
                              ? orderTenure.active[0].tenure.billingDay
                              : "Same as tenure start date"}
                          </Td>
                          <Td sx={tableRowBorder} fontSize={"xs"} p={3}>
                            {orderTenure.active[0].tenure.tenurePeriodId ===
                            "MONTHLY"
                              ? orderTenure.active[0].months + " Month"
                              : orderTenure.active[0].weeks + " Week"}{" "}
                          </Td>
                          <Td sx={tableRowBorder} fontSize={"xs"} p={3}>
                            <Badge
                              colorScheme={
                                orderTenure.active[0].tenure.statusId ===
                                "CANCELED"
                                  ? "red"
                                  : orderTenure.active[0].tenure.statusId ===
                                    "CREATED"
                                  ? "purple"
                                  : orderTenure.active[0].tenure.statusId ===
                                    "ACTIVE"
                                  ? "green"
                                  : "gray"
                              }
                            >
                              {orderTenure.active[0].tenure.statusId}
                            </Badge>
                          </Td>
                          {/* BillingDay */}
                        </Tr>

                        {orderTenure.extend.length > 0 &&
                          orderTenure.extend.map((x, i) => {
                            return (
                              <Tr key={i}>
                                <Td sx={tableRowBorder} fontSize={"xs"} p={3}>
                                  {x.tenureId}
                                </Td>
                                <Td sx={tableRowBorder} fontSize={"xs"} p={3}>
                                  {x.tenure.tenurePeriodId}
                                </Td>
                                <Td sx={tableRowBorder} fontSize={"xs"} p={3}>
                                  {new Date(
                                    x.tenure.startDate
                                  ).toLocaleDateString("en-IN")}
                                </Td>
                                <Td sx={tableRowBorder} fontSize={"xs"} p={3}>
                                  {new Date(
                                    x.tenure.endDate
                                  ).toLocaleDateString("en-IN")}
                                </Td>
                                <Td sx={tableRowBorder} fontSize={"xs"} p={3}>
                                  {x.tenure.tenurePeriodId === "MONTHLY"
                                    ? x.months + " Month"
                                    : x.weeks + " Week"}{" "}
                                </Td>
                                <Td sx={tableRowBorder} fontSize={"xs"} p={3}>
                                  <Badge colorScheme="yellow">
                                    {x.tenure.statusId}
                                  </Badge>
                                </Td>
                              </Tr>
                            );
                          })}
                      </Tbody>
                    </Table>
                  </TableContainer>
                </HStack>
              )}

            {/* Add this after the tenure table in the existing tenure details section */}
            {title === "Tenure" &&
              Object.keys(orderTenure).length > 0 &&
              orderTenure.active.length > 0 && (
                <Box p={3}>
                  <Divider my={2} />
                  <Flex alignItems="center">
                    <Text fontSize="sm" fontWeight={"semibold"} mr={2}>
                      Billing Day:{" "}
                      {orderTenure.active[0].tenure.billingDay ||
                        "Same as tenure start date"}
                    </Text>
                    <Button size="sm" colorScheme="blue" onClick={onOpen5}>
                      Change Billing Day
                    </Button>
                  </Flex>
                </Box>
              )}
          </Box>
        )}

        {title === "Order" && title2 !== "Order Delivery" && (
          <>
            <Box p={3} px={{ base: 3, md: 6, lg: 6, xl: 6, "2xl": 6 }} pt={0}>
              {(!orderData.shopifyOrderId.includes("-") ||
                orderData.draftOrderId) && (
                <Divider size={1} borderBottomColor={"black"} mb={2} />
              )}
              {!orderData.shopifyOrderId.includes("-") && (
                <Link
                  to={shopifyOrderPageUrl(false, orderData.shopifyOrderId)}
                  target="_blank"
                >
                  <Button size={"sm"} colorScheme={"blue"} mr={3}>
                    Shopify Order Page
                  </Button>
                </Link>
              )}
              {orderData.draftOrderId && (
                <Link
                  to={shopifyOrderPageUrl(true, orderData.draftOrderId)}
                  target="_blank"
                >
                  <Button size={"sm"} colorScheme={"cyan"}>
                    Shopify Draft Order Page
                  </Button>
                </Link>
              )}
              <Divider size={1} borderBottomColor={"black"} mt={2} />
              <Tags
                isTitle={false}
                orderData={orderData}
                orderDetails={orderDetails}
              />
            </Box>
          </>
        )}
      </Box>

      {/* Cancel tenure Alert box */}
      <AlertDialog isOpen={isOpen} onClose={onClose} isCentered>
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              CANCEL TENURE
            </AlertDialogHeader>

            <AlertDialogBody>
              Are you sure? You can't undo this action afterwards.
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button colorScheme="red" onClick={cancelTenureHandler} mr={3}>
                YES
              </Button>
              <Button colorScheme="blue" onClick={onClose}>
                NO
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>

      {/* Cancel tenure Alert box */}
      <AlertDialog isOpen={isOpen2} onClose={onClose2} isCentered>
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              CREATE RETURN
            </AlertDialogHeader>

            <AlertDialogBody>
              Are you sure? You can't undo this action afterwards.
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button colorScheme="red" onClick={createReturnHandler} mr={3}>
                YES
              </Button>
              <Button colorScheme="blue" onClick={onClose2}>
                NO
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>

      {/* Extend tenure Alert Box */}
      <AlertDialog isOpen={isOpen1} onClose={onClose1} isCentered>
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              EXTEND TENURE
            </AlertDialogHeader>

            <AlertDialogBody>
              Are you sure you want to extend this tenure? You can't undo this
              action afterwards.
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button colorScheme="red" onClick={extendTenureHandler} mr={3}>
                YES
              </Button>
              <Button colorScheme="blue" onClick={onClose1}>
                NO
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>

      {/* PICKUP DATE MODAL */}
      <Modal isOpen={isOpen3} onClose={onClose3}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader textAlign={"center"}>Reschedule Pickup Date</ModalHeader>
          <Divider />
          <ModalCloseButton />
          <ModalBody pb={6} textAlign={"center"}>
            <FormControl my={2} textAlign={"center"}>
              <FormLabel
                fontSize={"17px"}
                mb={1}
                fontWeight={"semibold"}
                letterSpacing={"wide"}
                textAlign={"center"}
              >
                Select Pickup Date
              </FormLabel>
              <DatePicker
                placeholder="Select Pickup date"
                className={"my-custom-datepicker"}
                selected={pickupDate}
                onChange={(date) => {
                  setPickupDate(date);
                }}
                minDate={new Date()}
                dateformat="dd/MM/yyyy"
                // filterDate={filterDays}
              />
            </FormControl>
          </ModalBody>
          <ModalFooter>
            <Button mr={3} onClick={onClose3}>
              Cancel
            </Button>
            <Button
              isDisabled={pickupDate.length === 0}
              colorScheme="blue"
              onClick={() => {
                reschedulePickupHandler();
              }}
            >
              Reschedule
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* Generate Tenure Invoice Modal */}
      <Modal isOpen={isOpen4} onClose={onClose4} size={"5xl"}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader textAlign={"center"}>
            Generate Tenure Invoice
          </ModalHeader>
          <Divider />
          <ModalCloseButton />
          <ModalBody pb={6} textAlign={"center"}>
            <TableContainer my={3} sx={tableBorder} width={"100%"}>
              <Table variant={"simple"} size={"xs"}>
                <Thead
                  borderRadius={"3px 3px 0px 0px"}
                  bgColor={"rgba(226, 223, 223, 1)"}
                >
                  <Tr>
                    <Th
                      p={3}
                      borderRight={"1px solid rgba(0, 0, 0, 0.17)"}
                      fontSize={"9px"}
                    >
                      Seq. ID
                    </Th>
                    <Th
                      p={3}
                      borderRight={"1px solid rgba(0, 0, 0, 0.17)"}
                      fontSize={"9px"}
                    >
                      Tenure Start Date
                    </Th>
                    <Th
                      p={3}
                      borderRight={"1px solid rgba(0, 0, 0, 0.17)"}
                      fontSize={"9px"}
                    >
                      Tenure End Date
                    </Th>
                    <Th
                      p={3}
                      _last={{ borderRight: "unset" }}
                      borderRight={"1px solid rgba(0, 0, 0, 0.17)"}
                      fontSize={"9px"}
                    >
                      Status
                    </Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {tenureInvoiceData &&
                    tenureInvoiceData.length > 0 &&
                    tenureInvoiceData?.map((x, i) => {
                      return (
                        <Tr key={i}>
                          <Td sx={tableRowBorder} fontSize={"xs"} p={3}>
                            {x?.tenureItemSeqId}
                          </Td>
                          <Td sx={tableRowBorder} fontSize={"xs"} p={3}>
                            {new Date(x?.startDate).toLocaleDateString("en-IN")}
                          </Td>
                          <Td sx={tableRowBorder} fontSize={"xs"} p={3}>
                            {new Date(x?.endDate).toLocaleDateString("en-IN")}
                          </Td>
                          <Td sx={tableRowBorder} fontSize={"xs"} p={3}>
                            {allTenureInvoice.some(
                              (n) =>
                                n.InvoiceItem[0].tenureItemSeqId ===
                                x?.tenureItemSeqId
                            ) ? (
                              <Button
                                colorScheme={"yellow"}
                                size={"xs"}
                                cursor={"default"}
                              >
                                Generated
                              </Button>
                            ) : (
                              <Button
                                colorScheme={"green"}
                                size={"xs"}
                                onClick={() =>
                                  generateInvoice(x?.tenureItemSeqId)
                                }
                              >
                                Generate
                              </Button>
                            )}
                          </Td>
                        </Tr>
                      );
                    })}
                </Tbody>
              </Table>
            </TableContainer>
          </ModalBody>
          <ModalFooter>
            <Button mr={3} onClick={onClose4}>
              Cancel
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* Add this modal at the end with other modals */}
      <Modal isOpen={isOpen5} onClose={onClose5}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Change Billing Day</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <FormControl>
              <FormLabel>Select Billing Day (1-15)</FormLabel>
              <Select
                placeholder="Select billing day"
                value={selectedBillingDay}
                onChange={(e) => setSelectedBillingDay(e.target.value)}
              >
                {[...Array(15)].map((_, i) => (
                  <option key={i + 1} value={i + 1}>
                    {i + 1}
                  </option>
                ))}
              </Select>
            </FormControl>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="blue" mr={3} onClick={updateBillingDay}>
              Save
            </Button>
            <Button onClick={onClose5}>Cancel</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  );
};

const ShowTable = ({ id, tableBorder, tableRowBorder, orderId }) => {
  const [orderTenure, setOrderTenure] = useState({});

  console.log(orderId, "checking here");

  useEffect(() => {
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_RALCO_API_URL}/api/tenure/get-tenure-list`,
      headers: {
        Authorization: Auth(),
      },
      data: { orderId: orderId },
    };

    axios
      .request(config)
      .then((response) => {
        // console.log(response, "show component")
        let myData = response.data.filter((x) => x.orderItemSeqId === id);
        let active = myData.filter((y) => y.statusId !== "EXTENDED");
        let extended = myData.filter((y) => y.statusId === "EXTENDED");
        setOrderTenure({ active: active, extend: extended });
        // console.log({active: active, extend: extended}, "here show")
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  return (
    <Box>
      {orderTenure && orderTenure.active && orderTenure.active.length > 0 && (
        <HStack spacing={10} py={2} my={2} justifyContent={"space-between"}>
          <TableContainer my={3} sx={tableBorder} width={"100%"}>
            <Table variant={"simple"} size={"xs"}>
              <Thead
                borderRadius={"3px 3px 0px 0px"}
                bgColor={"rgba(226, 223, 223, 1)"}
              >
                <Tr>
                  <Th
                    p={3}
                    borderRight={"1px solid rgba(0, 0, 0, 0.17)"}
                    fontSize={"9px"}
                  >
                    Tenure ID
                  </Th>
                  <Th
                    p={3}
                    borderRight={"1px solid rgba(0, 0, 0, 0.17)"}
                    fontSize={"9px"}
                  >
                    Tenure Type
                  </Th>
                  <Th
                    p={3}
                    borderRight={"1px solid rgba(0, 0, 0, 0.17)"}
                    fontSize={"9px"}
                  >
                    Tenure Start Date
                  </Th>
                  <Th
                    p={3}
                    borderRight={"1px solid rgba(0, 0, 0, 0.17)"}
                    fontSize={"9px"}
                  >
                    Tenure End Date
                  </Th>
                  <Th
                    p={3}
                    borderRight={"1px solid rgba(0, 0, 0, 0.17)"}
                    fontSize={"9px"}
                  >
                    Duration
                  </Th>
                  {/* <Th p={3}   _last={{borderRight: 'unset'}} borderRight={'1px solid rgba(0, 0, 0, 0.17)'} fontSize={'9px'}>Status</Th> */}
                </Tr>
              </Thead>
              <Tbody>
                <Tr>
                  <Td sx={tableRowBorder} fontSize={"xs"} p={3}>
                    <Link
                      to={`/tenures/order/${orderId}/tenure/${orderTenure?.active[0]?.tenureId}`}
                    >
                      <Text color={"blue.500"}>
                        #{orderTenure.active[0].tenureId}
                      </Text>
                    </Link>
                  </Td>
                  <Td sx={tableRowBorder} fontSize={"xs"} p={3}>
                    {orderTenure?.active[0]?.tenure?.tenurePeriodId}
                  </Td>
                  <Td sx={tableRowBorder} fontSize={"xs"} p={3}>
                    {new Date(
                      orderTenure.active[0].tenure.startDate
                    ).toLocaleDateString("en-IN")}
                  </Td>
                  <Td sx={tableRowBorder} fontSize={"xs"} p={3}>
                    {new Date(
                      orderTenure.active[0].tenure.endDate
                    ).toLocaleDateString("en-IN")}
                  </Td>
                  <Td sx={tableRowBorder} fontSize={"xs"} p={3}>
                    {orderTenure.active[0].tenure.tenurePeriodId === "MONTHLY"
                      ? orderTenure.active[0].months + " Month"
                      : orderTenure.active[0].weeks + " Week"}{" "}
                  </Td>
                  {/* <Td sx={tableRowBorder} fontSize={'xs'} p={3}><Badge colorScheme={orderTenure.active[0].tenure.statusId === 'CANCELED' ? 'red' : orderTenure.active[0].tenure.statusId === 'CREATED' ? 'purple' : orderTenure.active[0].tenure.statusId === 'ACTIVE' ? 'green' : 'gray'}>{orderTenure.active[0].tenure.statusId}</Badge></Td> */}
                </Tr>

                {orderTenure &&
                  orderTenure.extend &&
                  orderTenure.extend.length > 0 &&
                  orderTenure.extend.map((x, i) => {
                    return (
                      <Tr key={i}>
                        <Td sx={tableRowBorder} fontSize={"xs"} p={3}>
                          <Link
                            to={`/tenures/order/${orderId}/tenure/${x.tenureId}`}
                          >
                            <Text color={"blue.500"}>#{x.tenureId}</Text>
                          </Link>
                        </Td>
                        <Td sx={tableRowBorder} fontSize={"xs"} p={3}>
                          {x.tenure.tenurePeriodId}
                        </Td>
                        <Td sx={tableRowBorder} fontSize={"xs"} p={3}>
                          {new Date(x.tenure.startDate).toLocaleDateString(
                            "en-IN"
                          )}
                        </Td>
                        <Td sx={tableRowBorder} fontSize={"xs"} p={3}>
                          {new Date(x.tenure.endDate).toLocaleDateString(
                            "en-IN"
                          )}
                        </Td>
                        <Td sx={tableRowBorder} fontSize={"xs"} p={3}>
                          {x.tenure.tenurePeriodId === "MONTHLY"
                            ? x.months + " Month"
                            : x.weeks + " Week"}{" "}
                        </Td>
                        {/* <Td sx={tableRowBorder} fontSize={'xs'} p={3}><Badge colorScheme='yellow'>{x.tenure.statusId}</Badge></Td> */}
                      </Tr>
                    );
                  })}
              </Tbody>
            </Table>
          </TableContainer>
        </HStack>
      )}
    </Box>
  );
};

export default Details;
